
//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);

if(ie) {
  $(".img-container").each(function () {
    var $container = $(this),
        imgUrl = $container.find("img").prop("src");
    if (imgUrl) {
      $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("custom-object-fit");
    }
  });
}

function writeCookie(key, value, days) {
  let date = new Date();
  days = days || 7;
  date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000
  window.document.cookie = key + "=" + value + "; expires=" + date.toGMTString() + "; path=/";
  return value;
}


window.onload = (function(){
    //preloader
    var root = document.getElementsByTagName( 'html' )[0];
    root.classList.add("site-loaded");
    // document.body.classList.add("loaded");
});

/* Nav Trigger */
document.getElementById('nav-trigger').addEventListener("click", toggleNav);

function toggleNav() {
    this.parentNode.classList.toggle('active');
}


if(document.querySelector('.region-switcher .region a')){
    document.querySelector('.region-switcher .region.active a').addEventListener("click", function(e){
        e.preventDefault();
        document.querySelector('.region-switcher').classList.toggle('active');
    });
}




/* Slide Function */
function slide(track, numSlides, offset, numShowingDesk, numShowingTablet, numShowingMobile, autoPlay, timeout, linkList, arrows) {

    // VARIABLES
    var track = track, // slider track
        numSlides = numSlides, // total number of slides calculated
        newOffset = offset, //set initial offset
        numShowingDesk = numShowingDesk,
        numShowingTablet = numShowingTablet,
        numShowingMobile = numShowingMobile,
        autoPlay = autoPlay, // should it slide on its own
        timeout = timeout, // auto slide delay
        linkList = linkList, // jump links to slides
        arrows = arrows,

        newSlideWidth = 100/numShowingDesk, // calculate the slide width from numShowing on desktop
        newNumShowing = numShowingDesk, // set current number of slides showing to desktop
        currentSlide = 0; //set initial slide to the first
        

    // wrap added in css in case broken... remove it initially
    track.style.flexWrap = 'nowrap';

    function setSizes(){
        //alert('setsizes');
        track.style.transform = 'translate('+newOffset+'%, 0)'; //add offset
        track.style.width = newSlideWidth*numSlides+'%';
    }

    function setMobileSizes(){
        track.style.transform = 'translate(0, 0)'; //remove offset
        track.style.width = newSlideWidth*numSlides+'%';
    }

    function setTabletSizes(){
        track.style.transform = 'translate(0, 0)'; //remove offset
        track.style.width = newSlideWidth*numSlides+'%';
    }


   
    // add click event to links
    if(typeof(linkList) != 'undefined' && linkList != null){
        var links = linkList.getElementsByClassName("slider-link");
        for (var i = 0; i < links.length; i++) {
            links[i].addEventListener('click', linkJump, false);
        }
    };

    if(typeof(arrows) != 'undefined' && arrows != null){
        arrows.querySelector('.arrow-button:first-of-type').addEventListener('click', prevSlideClick, false);
        arrows.querySelector('.arrow-button:last-of-type').addEventListener('click', nextSlideClick, false);
    }

    track.parentElement.parentElement.querySelector('div.next').addEventListener('click', nextSlideClick, false);
    track.parentElement.parentElement.querySelector('div.prev').addEventListener('click', prevSlideClick, false);


    function linkJump(){
        var listElem = this.parentElement; //li of clicked
        var parent = listElem.parentNode; // ul
        var index = Array.prototype.indexOf.call(parent.children, listElem);
        currentSlide = index;
        updateSlide(index);
    }; 

    function updateButtons(i){
        slideNum = i;
        var listElem = linkList.querySelector("li:nth-of-type("+(slideNum+1)+")"); // li of clicked
        var parent = listElem.parentNode; // ul


        // SET BUTTON AS ACTIVE
        var allChildren = parent.children; //all li's
        var totalWidth = 0; // width of total li's

        for (var i = 0; i < allChildren.length; i++) {
            allChildren[i].classList.remove("active"); // remove active from all li's
            totalWidth = totalWidth + allChildren[i].offsetWidth; // add total width of all li's
        }

        listElem.classList.add("active"); // set active on clicked li

        // UPDATE SLIDER POSITION
        // if width of links is longer than its container, scroll to the start on click (mobile)
        if(totalWidth > parent.offsetWidth){
            if(listElem.offsetLeft < (totalWidth - parent.offsetWidth)){ // check if the last element is offscreen
                var leftAmount = listElem.offsetLeft*-1;
                parent.style.transform = 'translate('+leftAmount+'px, 0)';
            }
            
        } else {
            parent.style.transform = 'translate(0px, 0)'; //else reset to start
        }
    }
        

    function updateSlide(i){
        slideNum = i;
        translateAmount = slideNum * -(100/numSlides)+newOffset+'%';
        track.style.transform = 'translate('+translateAmount+', 0)';
        currentSlide = slideNum;

        if(typeof(linkList) != 'undefined' && linkList != null){
            updateButtons(currentSlide);
        }
    };

    function nextSlide(){
        if(currentSlide < numSlides-newNumShowing){
            updateSlide(currentSlide+1);
        } else {
            updateSlide(0)
        }
    }

    function prevSlide(){
        if(currentSlide > 0){
            updateSlide(currentSlide-1);
        }
    }

    function nextSlideClick(){
        autoPlay = false;
        nextSlide();
    }

    function prevSlideClick(){
        autoPlay = false;
        prevSlide();
    }

    
    function autoSlide() {

        var int = setInterval((function() {
            
            // if all characters were used
            if (autoPlay === false) {
                clearInterval(int);
                return;
            }
            nextSlide()
        }), timeout);
    }
    if(autoPlay == true){
       autoSlide(); 
    }


    // track.swipeDetector()
    //     .on("swipeLeft.sd swipeRight.sd swipeUp.sd swipeDown.sd", function(event) {
    //         if (event.type === "swipeLeft") {
    //             nextSlide();
    //         } else if (event.type === "swipeRight") {
    //             prevSlide();
    //         }
    // });

    // window resize
    window.addEventListener('resize', function(event){
      // do stuff here
      if(window.innerWidth < 768){
            newOffset = 0; // remove offset on mobile
            newNumShowing = numShowingMobile;
            newSlideWidth = 100/numShowingMobile; //set to 100 on mobile

            setMobileSizes();
        } else if(window.innerWidth < 1280){
            newOffset = 0; // remove offset on tablet
            newNumShowing = numShowingTablet;
            newSlideWidth = 100/numShowingTablet; //set to 50 on taablet
            
            setTabletSizes();
        } else {
            newOffset = offset;
            newNumShowing = numShowingDesk;
            newSlideWidth = 100/numShowingDesk;
            
            setSizes();
        }
    });

    setSizes();
    window.dispatchEvent(new Event('resize'));
}
/* END SLIDER */


// efficient debounce resize https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
var myEfficientFn = debounce(function() {
  if(window.innerWidth <= 1024){
    //mobileDerrivative();
    window.responsive = 'touch';
    //console.log('touch');
  } else {
    //desktopDerrivative();
    window.responsive = 'desktop';
    //console.log('desktop');
  }
}, 250);
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
window.addEventListener('resize', myEfficientFn);
myEfficientFn();

document.addEventListener('DOMContentLoaded', () => {


  // Promo Popup
  let newsletterPopup = document.querySelector('#newsletter-popup');
  if (newsletterPopup) {
    setTimeout(() => { newsletterPopup.style.display = 'flex' }, parseInt(newsletterPopup.dataset.delay)/2);
    setTimeout(() => { document.body.classList.add('show-newsletter') }, parseInt(newsletterPopup.dataset.delay));
    document.querySelector('#newsletter-close').addEventListener('click', () => {
      document.body.classList.remove('show-newsletter');
      setTimeout(() => { newsletterPopup.classList.add('dismissed') }, 1000);
      writeCookie('newsletter_dismissed', 'true', newsletterPopup.dataset.expiry)
    })
  }
  // END Promo Popup
});
